import {useSelector} from 'react-redux';

import useAvailableFwu from '../../../../hooks/fwu/useAvailableFwu';
import {selectIsMobileLayout} from '../../../../state/selectors/global';

const useUpdateAvailableEnabled = () => {
    const isMobileLayout = useSelector(selectIsMobileLayout);
    const {isAnyFwuAvailable} = useAvailableFwu();

    return isAnyFwuAvailable && !isMobileLayout;
};

export default useUpdateAvailableEnabled;
